<template>
    <div>
        <PageHeader>
            {{ $t('sales') }}
            <template #side>
                <div class="d-flex gap-3">
                    <ButtonResetFilters @click="resetFilters()" />
                    <TimeRangeCalendar ref="TimeRangeCalendar" v-model="timeRange" compare-year />
                </div>
            </template>
        </PageHeader>

        <SalesOverview />
        <SalesSalesSummary />
        <SalesBySource />
        <SalesSummary />
        <SalesTransactions />
        <SalesProductDetails />
        <SalesPriceRange />
    </div>
</template>

<script>
    import ButtonResetFilters from '@/components/common/ButtonResetFilters.vue';
    import TimeRangeCalendar from '@/components/common/TimeRangeCalendar.vue';

    import SalesOverview from './parts/SalesOverview.vue';
    import SalesBySource from './parts/SalesBySource.vue';
    import SalesSummary from './parts/SalesSummary.vue';
    import SalesTransactions from './parts/SalesTransactions.vue';
    import SalesPriceRange from './parts/SalesPriceRange.vue';
    import SalesSalesSummary from './parts/SalesSalesSummary.vue';
    import SalesProductDetails from './parts/SalesProductDetails.vue';

    export default {
        name: 'ReportsSales',
        components: {
            ButtonResetFilters,
            TimeRangeCalendar,
            SalesOverview,
            SalesBySource,
            SalesSummary,
            SalesTransactions,
            SalesPriceRange,
            SalesSalesSummary,
            SalesProductDetails,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                timeRange: null,
            };
        },
        methods: {
            resetFilters() {
                this.$emit('resetFilters');
                this.$refs.TimeRangeCalendar.resetDate();
            },
        },
    };
</script>
